import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { LastRechtGrundstueckEntryMeta } from '../../../core/gb-api';

@Pipe({
  name: 'belastungArt'
})
export class BelastungArtPipe implements PipeTransform {
  constructor(private translate: TranslateService) {
    keysToTranslate<string>(['Last', 'Recht', 'LastRechtAbkürzung', 'DOMINANTINDENT']);
  }

  transform(value: LastRechtGrundstueckEntryMeta.BelastungArtEnum, langChangeEvent = 'de'): any {
    switch (value) {
      case 'BELASTET':
        return this.translate.instant('Last');
      case 'BERECHTIGT':
        return this.translate.instant('Recht');
      case 'BELASTET_BERECHTIGT':
        return this.translate.instant('LR');
      case 'DOMINANTINDET':
        return this.translate.instant('DominantIndet');
    }
    return null;
  }
}
